import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';
import moment from 'moment'

import SimpleImageSlider from "../../../components/ImageSlider/ImageSlider.jsx";
import { modal } from '../../../core/utilities/modal'
import { phoneNumberFormatter } from '../../../helpers/General/PhoneNunberFormatter'
import { user } from '../../../core/controllers/user';
import { listings } from '../../../core/controllers/Listings';
import { lead } from '../../../core/controllers/Lead';

export default class ListingsTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            slug: this.props.slug,
            listings: [],
            viewSingleListing: false,
            activeListing: null,
            showContact: false,
            lead: {
                firstname: '',
                lastname: '',
                phone: '',
                email: ''
            }
        }
    }

    componentDidMount() {
        var self = this;
        if (this.state.slug == null || this.state.slug == '') {
            browserHistory.replace('/login');
        }

        user.validateCompanySlug(this.state.slug, function(response) {
            if(response == false) {
                browserHistory.replace('/login');
            } else {
                listings.getPublicListings(self.state.slug, function(response) {
                    self.setState({
                        listings: response.data
                    });
                });
            }
        });
    }

    formatDate(date) {
        if(date) {
            return moment(date).format('MMMM Do YYYY');
        } else {
            return 'Not Set';
        }
    }

    openListing(listing) {
        this.setState({
            viewSingleListing: true,
            activeListing: listing,
            showContact: false
        });
    }

    backToListings() {
        this.setState({
            viewSingleListing: false,
            activeListing: null,
            showContact: false
        });
    }

    clickedContactus(listing) {
        this.setState({
            viewSingleListing: true,
            showContact: true
        });
    }

    handleFirstnameChange(e){
        this.setState({
            lead: update(this.state.lead, {
                firstname: {$set: e.target.value
                }}
            )
        });
    }

    handleLastnameChange(e){
        this.setState({
            lead: update(this.state.lead, {
                lastname: {$set: e.target.value
                }}
            )
        });
    }

    handleEmailChange(e){
        this.setState({
            lead: update(this.state.lead, {
                email: {$set: e.target.value
                }}
            )
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            lead: update(this.state.lead, {
                phone: {$set: phoneNumber
                }}
            )
        });
    }

    goBackToActiveListing() {
        this.setState({
            showContact: false
        });
    }

    sendLead(activeListing) {
        var self = this;
        if(!this.validate()) {
            return;
        }

        var data = {
            listing: activeListing,
            lead: this.state.lead
        }

        lead.savePublicListingLead(data, function(response) {
            self.setState({
                showContact: false
            })
            modal.showInfo("We've received your request and will be in touch soon!", "success", "top", "center");
        });
    }

    validate() {
        const enteredData = this.state.lead;
        const email = enteredData.email;
        const firstname = enteredData.firstname;
        const lastname = enteredData.lastname;
        const phonenumber = enteredData.phone;

        if(firstname === undefined || firstname.length == 0) {
            modal.showInfo("Please enter your firstname.", "warning", "top", "center");
            return false;
        }

        if(lastname === undefined || lastname.length == 0) {
            modal.showInfo("Please enter your lastname.", "warning", "top", "center");
            return false;
        }

        if(email === undefined || email.length == 0) {
            modal.showInfo("Please enter your email.", "warning", "top", "center");
            return false;
        }

        if(email && email.length > 0) {
            const lastAtPos = email.lastIndexOf('@');
            const lastDotPos = email.lastIndexOf('.');
            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
                modal.showInfo("Email is invalid.", "warning", "top", "center");
                return false;
            }
        }

        if(phonenumber === undefined || phonenumber.length == 0) {
            modal.showInfo("Please enter your phone number.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    render(){
        var self = this;
        const companySlug = this.state.slug;
        const activeListing = this.state.activeListing;
        const viewSingleListing = this.state.viewSingleListing;
        const listings = this.state.listings;
        const showContact = this.state.showContact;
        const firstname = this.state.lead.firstname;
        const lastname = this.state.lead.lastname;
        const phone = this.state.lead.phone;
        const email = this.state.lead.email;
        var listingCards = [];
        if(listings != null) {
            listingCards = listings.map(function(listing) {
                return (
                    <div class="col-md-6 col-sm-6 col-xs-12 property-card" key={listing.details.listing_id} onClick={self.openListing.bind(self, listing)}>
                        <div class="col-md-12">
                        {listing.photo == null ? (
                            <div class="property-photo">
                                <p>No property cover image.</p>
                            </div>
                        ) : (
                            <div class="property-photo">
                                <img src={listing.photo.url} width="100%" />
                            </div>
                        )}
                            <div class="property-details">
                                <div class="header">
                                    <h4 class="title">{listing.details.listing_name}</h4>
                                    <p class="category">
                                        {listing.details.listing_description}<br/>{listing.property.property_address}<br/> {listing.property.property_city} {listing.property.property_state}, {listing.property.property_zip}
                                        <br/>
                                        <i class="fa fa-clock-o"></i> Listed {self.formatDate(listing.details.created_at)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            });
        }

        if (viewSingleListing) {
            var singleUnit = true;
            if (activeListing.units.length > 0) {
                singleUnit = false;
            }
            if (showContact) {
                return (
                    <div>
                    <img class="background-image" src="/assets/img/kc_downtown.png" />
                    <div class="login-page screen-page">
                        <div class="login-box">
                            <div class="login-box-body">
                                <div class="card">
                                    <div class="header">
                                        <h4 class="title" style={{textAlign: 'center', padding: '10px'}}>{activeListing.details.listing_name}</h4>
                                        <p class="category"></p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="assignee">Firstname</label>
                                                <input type="text" value={firstname} class="form-control tenant-info" name="title" placeholder="Jane" id="title" onChange={this.handleFirstnameChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="assignee">Lastname</label>
                                                <input type="text" value={lastname} class="form-control tenant-info" name="title" placeholder="Smith" id="title" onChange={this.handleLastnameChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="assignee">Phone</label>
                                                <input type="text" value={phone} class="form-control tenant-info" name="title" placeholder="999-888-8888" id="title" onChange={this.handlePhoneChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="assignee">Email</label>
                                                <input type="text" value={email} class="form-control tenant-info" name="title" placeholder="jane@example.com" id="title" onChange={this.handleEmailChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-sm-12 col-xs-12">
                                            <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-left" autoComplete="off" onClick={this.goBackToActiveListing.bind(this)}>
                                                Go Back
                                            </button>
                                            <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" onClick={this.sendLead.bind(this, activeListing)}>
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                )
            } else {
                var noImages = false;
                var formattedImages = [];
                if (activeListing.images.length == 0) {
                    noImages = true;
                } else {
                    activeListing.images.forEach(image => {
                        formattedImages.push({url: image.url});
                    });
                }
                return (
                    <div>
                    <img class="background-image" src="/assets/img/kc_downtown.png" />
                    <div class="login-page screen-page">
                        <div class="login-box">
                            <div class="login-box-body">
                                <div class="card">
                                    <div class="header">
                                        <h4 class="title" style={{textAlign: 'center', padding: '10px'}}>{activeListing.details.listing_name}</h4>
                                        <p class="category"></p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12 col-xs-12 property-card">
                                            <div class="col-md-12">
                                            {activeListing.photo == null ? (
                                                <div class="property-photo">
                                                    <p>No property cover image.</p>
                                                </div>
                                            ) : (
                                                <div class="property-photo">
                                                    <img src={activeListing.photo.url} width="100%" />
                                                </div>
                                            )}
                                                <div class="property-details-public">
                                                    <div class="header">
                                                        <h4 class="title">{activeListing.details.listing_name}</h4>
                                                        <p class="category">
                                                            {activeListing.details.listing_description}<br/>{activeListing.property.property_address}<br/> {activeListing.property.property_city} {activeListing.property.property_state}, {activeListing.property.property_zip}
                                                            <br/>
                                                            <i class="fa fa-clock-o"></i> Listed {self.formatDate(activeListing.details.created_at)}
                                                        </p>
                                                        <h4 class="title">
                                                            { singleUnit == false && (
                                                                <span>
                                                                {activeListing.units.length} units available
                                                                </span>
                                                            )}
                                                        </h4>
                                                    </div>
                                                    <div class="content">
                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12 col-xs-12">
                                                                <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" style={{width: '100%', marginBottom: '15px'}} onClick={this.clickedContactus.bind(this, activeListing)}>
                                                                    Contact Us
                                                                </button>
                                                                <button type="button" id="add-tenant" data-loading-text="Loading..." class="add-tenant btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" style={{width: '100%', marginBottom: '15px'}} onClick={this.backToListings.bind(this)}>
                                                                    Back to Listings
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12 col-xs-12">
                                                                <h4 class="title">Listing Images</h4>
                                                            </div>
                                                            { noImages ? (
                                                                <div class="col-md-12 col-sm-12 col-xs-12">
                                                                    <p>No images available.</p>
                                                                </div>
                                                            ) : (
                                                                <div class="col-md-12 col-sm-12 col-xs-12">
                                                                    <SimpleImageSlider
                                                                        width={"95%"}
                                                                        height={500}
                                                                        images={formattedImages}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                )
            }
        } else {
            return (
                <div>
                <img class="background-image" src="/assets/img/kc_downtown.png" />
                <div class="login-page screen-page">
                    <div class="login-box">
                        <div class="logo">
                            {/* <a href="#"><img src="/assets/img/logo_no_tag.png" alt="Logo" width="150px" /></a> */}
                        </div>
                        <div class="login-logo">
                            {/* <a href="#"><b>Hey, </b>{ tenant }!</a> */}
                        </div>
                        <div class="login-box-body">
                            <div class="card">
                                <div class="header">
                                    <h4 class="title" style={{textAlign: 'center', padding: '10px'}}>Our Current Listings</h4>
                                    <p class="category"></p>
                                </div>
                                <div class="row">
                                    { listingCards }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/views/Listings/Public/Listings.jsx